import { useEffect , useState } from 'react';
import { priceFormat } from 'util/prices';
import useProductCard from 'newHooks/useProductCard';
import { repareImage } from 'newFunctions/repareDataService';
import arrow from 'assets/img/select-arrow-open.svg';
import ProductModal from 'newComponents/ProductsModal/ProductTC';
import styles from '../styles.module.sass'


const CardProduct = (props) => {

    const {
        item
    } = props

    const {
        producto,
        image,
        addMore,
        IsGiftTC,
        amount,
        productTC,
        clickAddProductTC,
        clickModalProduct,
        removeProduct,
        updateCant,
        sendCant,
        moreCant,
        minCant
    } = useProductCard({item})

    const [ productActive, setProductActive ] =  useState(true)

    const handleClose = () => {
        clickModalProduct( {showModal: false} )
    }

    const isMobile = 'desktop'

    useEffect(()=>{
        if(producto){
            if(producto?.stock >= 1 && producto?.is_active){
                setProductActive(false)
            }
        }
    },[ producto ])

    useEffect(()=>{},[ addMore ])

    return(
        <>
            <article className={styles?.cardProduct} data-type={producto?.id}>
                
                {productActive
                    ?
                        <div className={styles?.soldOut}> Agotado</div>
                    : null
                }
                
                <img src={repareImage(image)} alt={producto?.title} className={!productActive ? styles?.imageProduct : `${styles?.imageProduct} ${styles?.disabled}`} />
                
                <div className={styles?.contProductInt}>
                    <p className={styles?.title}>{producto?.title}</p>
                    <div className={styles?.contPrices}>
                        <p className={styles?.salesPrice}>${priceFormat(producto?.pricing?.list_price)} MXN</p>
                    </div>
                    {addMore && !IsGiftTC 
                        ?
                            producto?.stock >= 1 && producto?.is_active
                                ?
                                    <div className={styles?.contInput}>
                                        <input 
                                            name={`${producto?.id}_product`} 
                                            min="1" 
                                            max="22"
                                            step="1" 
                                            placeholder="" 
                                            maxLength="100" 
                                            type="number"
                                            onChange={updateCant}
                                            onBlur={sendCant}
                                            value={amount} 
                                            disabled={producto?.stock >= 1 && producto?.is_active ? null : 'disabled'}
                                        />
                                        <div className={styles?.contBtnsUpdate}>
                                            <img onClick={moreCant} className={styles?.topArrow} src={arrow} alt="Incrementar" aria-hidden="true" />
                                            <img onClick={minCant} className={styles?.bottomArrow} src={arrow} alt="Restar" aria-hidden="true" />
                                        </div>
                                    </div>
                                : null
                        : null
                    }
                    <div>
                        <div className="btn underlineButton btn-block" onClick={removeProduct} aria-hidden="true" >Eliminar</div>
                    </div>
                    <div className={styles?.totalStock}>
                        <span>{producto?.gifted}</span> de <span>{amount}</span></div>
                </div>
            </article>

            <ProductModal
                modalTC
                handleClose={handleClose}
                isMobile={isMobile}
                title={isMobile === 'desktop' ? 'Promociones' : 'Promociones Sanborns'} 
                product={productTC}
                clickAddProduct={clickAddProductTC}
                image
            />
        </>
    )
}

export default CardProduct